import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { coldarkDark as CodeStyle } from "react-syntax-highlighter/dist/esm/styles/prism";
import { useDebouncedCallback } from "use-debounce";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useUserProfile } from "../../service/hooks";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import WeatherIcon from "./WeatherCodeIcon";
import ReactCountryFlag from "react-country-flag";

import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Navbar,
  Image,
  Card,
  Badge,
  Spinner,
  Nav,
  Dropdown,
  Accordion,
  FormControl,
  InputGroup,
  DropdownDivider,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

import { useHistory, useParams, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faSignOutAlt,
  faMicrophone,
  faPaperclip,
  faLocationPin,
  faClock,
  faMagicWandSparkles,
  faHistory,
  faEnvelope,
  faPerson,
  faTrash,
  faGlobe,
  faCheckCircle,
  faTimes,
  faSearch,
  faShieldAlt,
  faUserEdit,
  faCross,
  faClose,
  faSpinner,
  faFileDownload,
  faDownload,
  faCloudDownloadAlt,
  faLink,
  faCompassDrafting,
  faMusic,
  faIdBadge,
} from "@fortawesome/free-solid-svg-icons";

import { useMediaQuery } from "react-responsive";

import csvFileIcon from "../../csv.svg";
import imageFileIcon from "../../image.svg";
import pdfFileIcon from "../../pdf.svg";
import textFileIcon from "../../text.svg";
import excelFileIcon from "../../excel.svg";

import "./Chat.css"; // Custom styles
import Offcanvas from "react-bootstrap/Offcanvas";
import Logo from "../../beatai-logo.svg";
// import Markdown from "react-markdown";
import Markdown from "markdown-to-jsx";

import {
  addAttachementToChat,
  addMessageToChat,
  API_BASE_URL,
  autoSuggest,
  changeAvatar,
  createChat,
  deleteChat,
  downloadAttachment,
  getChatMessages,
  getChats,
  getDefaultEvents,
  resendVerification,
  searchChats,
} from "../../service/api";

import WeatherMsg from "./WeatherMsg";
import StockQuoteCard from "./StockQuoteMsg";
import TimeLocationCard from "./DateAndTimeCard";
import NewsCard from "./NewsCard";
import Map from "./Map";
import Avatar, { useAvatar } from "../auth/Avatar";
import ModelCapabilities from "./ModelCapabilities";
import InternetSearch from "./InternetSearch";
import MeetLex from "./MeetLex";
import OffCanvNavigate from "./OffCanvNavigate";
import { APIProvider } from "@vis.gl/react-google-maps";
import EmbeddedChatMap from "./EmbeddedChatMap";
import { useSocket } from "../../service/sockt";
import ChartComponent from "./Echarts";

const MAP_KEY = "AIzaSyDLBkpoDCqAvqay94aOkYFf9Qry3WYZ6hs";

const formatTime = (timeString) =>
  /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(timeString)
    ? timeString.slice(0, 5)
    : null;

function EventVenue({
  classification,
  title,
  alink,
  venue,
  time,
  imglink,
  stateCode,
  stateName,
  countryCode,
  city,
  country,
}) {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const titleMaxSize = isTabletOrMobile ? 19 : 35;
  const venueMaxSize = isTabletOrMobile ? 16 : 18;

  return (
    <Card
      className="evt-card border-0 m-2"
      style={{
        cursor: "pointer",
        minHeight: isTabletOrMobile ? "360px" : "320px",
      }}
      onClick={() => {
        const link = document.createElement("a");
        link.href = alink;
        link.target = "_blank";
        link.rel = "noopener noreferrer"; // Recommended for security
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }}
    >
      <div className="evt-img-cont">
        <Image
          src={imglink}
          alt="Event image"
          style={{
            minHeight: "120px",
            maxHeight: "120px",
            objectFit: "cover",
          }}
        />
      </div>
      <Card.Body
        style={
          isTabletOrMobile
            ? {
                paddingTop: "10px",
                paddingLeft: "3px",
                paddingRight: "3px",
              }
            : {}
        }
      >
        <div style={{ minHeight: "60px", maxHeight: "60px", color: "#d9d9d9" }}>
          <h6 title={title}>
            {title.substring(
              0,
              title.length > titleMaxSize ? titleMaxSize : title.length
            )}
            {title.length > titleMaxSize && "..."}
          </h6>{" "}
          <br />
        </div>
        <FontAwesomeIcon size="xs" icon={faLocationPin} />{" "}
        {venue && venue.trim().length > 0 ? (
          <a
            style={{ marginTop: "15px" }}
            href={alink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white"
            style={{
              textDecoration: "underline",
              fontSize: isTabletOrMobile ? "10px" : "12px",
            }}
            title={venue ? venue : "unknown"}
          >
            {venue.substring(
              0,
              venue.length > venueMaxSize ? venueMaxSize : venue.length
            )}
            {venue.length > venueMaxSize && "..."}
          </a>
        ) : (
          "-"
        )}
        {/* <div className="">
          {Array.isArray(classification) &&
            classification.map((c, i) => {
              return <p className="classifications">{c}</p>;
            })}
        </div> */}
        <br />
        <p
          style={{
            fontSize: "0.8em",
            marginBottom: "6px",
            marginTop: "6px",
          }}
        >
          <FontAwesomeIcon size="xs" icon={faClock} /> {time}
        </p>
        <p
          style={{
            fontSize: "0.8em",
          }}
        >
          {countryCode || stateCode ? <FontAwesomeIcon icon={faGlobe} /> : ""}{" "}
          {countryCode ? (
            <ReactCountryFlag
              countryCode={countryCode}
              svg
              cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
              cdnSuffix="svg"
              title={countryCode}
            />
          ) : (
            ""
          )}
          {stateCode ? (
            <p title={stateCode} className="classifications">
              {stateCode}
            </p>
          ) : (
            ""
          )}{" "}
          {city}
          {city && country ? ", " : ""}
          {country === "United States Of America"
            ? stateName
              ? stateName
              : "USA"
            : country}
        </p>
      </Card.Body>
    </Card>
  );
}

function QueryResultEventCard({
  title,
  alink,
  venue,
  time,
  imglink,
  classification,
  countryCode,
  stateCode,
  stateName,
  city,
  country,
}) {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const titleMaxSize = isTabletOrMobile ? 24 : 42;
  const venueMaxSize = isTabletOrMobile ? 20 : 38;

  return (
    <Card
      className="q-evt-card border-0"
      style={{ cursor: "pointer" }}
      onClick={() => {
        const link = document.createElement("a");
        link.href = alink;
        link.target = "_blank";
        link.rel = "noopener noreferrer"; // Recommended for security
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }}
    >
      <Card.Body>
        <Row>
          <Col sm={4} md={4} x={4}>
            <Image
              src={imglink}
              style={{
                position: "relative",
                top: -26,
                left: -10,
                height: "75px",
                width: "75px",
                borderRadius: "10px",
                objectFit: "cover",
                marginRight: "10px",
              }}
              alt="Event image"
            />
          </Col>
          <Col sm={8} md={8} xs={8}>
            <div style={{ minHeight: "60px", maxHeight: "60px" }}>
              <p title={title}>
                {title.substring(
                  0,
                  title.length > titleMaxSize ? titleMaxSize : title.length
                )}
                {title.length > titleMaxSize && "..."}
              </p>{" "}
              <br />
            </div>
            <a
              href={alink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: isTabletOrMobile ? "0.9em" : "0.9em",
                marginBottom: "7px",
                color: "#d9d9d9",
              }}
            >
              {venue ? <FontAwesomeIcon size="xs" icon={faLocationPin} /> : ""}{" "}
              {venue.substring(
                0,
                venue.length > venueMaxSize ? venueMaxSize : venue.length
              )}
              {venue.length > venueMaxSize && "..."}
            </a>
            <p style={{ color: "#d9d9d9", marginBottom: "7px" }}>
              <FontAwesomeIcon size="xs" icon={faClock} /> {time}
            </p>
            <p
              style={{
                fontSize: isTabletOrMobile ? "0.9em" : "0.9em",
              }}
            >
              {countryCode || stateCode ? (
                <FontAwesomeIcon icon={faGlobe} />
              ) : (
                ""
              )}{" "}
              {countryCode ? (
                <ReactCountryFlag
                  countryCode={countryCode}
                  svg
                  cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                  cdnSuffix="svg"
                  title={countryCode}
                />
              ) : (
                ""
              )}
              {stateCode ? (
                <p title={stateCode} className="classifications">
                  {stateCode}
                </p>
              ) : (
                ""
              )}{" "}
              {city}
              {city && country ? ", " : ""}
              {country === "United States Of America"
                ? stateName
                  ? stateName
                  : "USA"
                : country}
            </p>
          </Col>
        </Row>
      </Card.Body>
      <Card.Footer>
        {Array.isArray(classification) &&
          classification.map((c, i) => {
            return <p className="classifications">{c}</p>;
          })}
      </Card.Footer>
    </Card>
  );
}

// CSS to be added to your stylesheet
const inputAnimStyles = `
.thinking-border {
  width: 100%;
  background: linear-gradient(
    90deg,
    rgb(88, 31, 140) 0%,
    rgb(100, 83, 150) 25%,
    rgb(88, 31, 140) 50%,
    rgb(100, 83, 150) 75%,
    rgb(88, 31, 140) 100%
  );
  background-size: 200% 100%;
  animation: moveGradient 2s linear infinite;
  position: relative;
  box-sizing: border-box;
  display: inline-block;
  padding: 1px;
  border-radius: 0.39rem;
}

.thinking-border > div {
  box-sizing: border-box;
  margin: 0;
  width: 100%;
}

.thinking-border > div > * {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: none;
}

@keyframes moveGradient {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 200% 0%;
  }
}
`;

function Chat() {
  const notFoundChat = () =>
    toast("Chat wasn't found! Redirecting to new chat..", {
      position: "top-right",
    });

  const failureFetchEvents = () =>
    toast(
      "There was an issue fetching events! Please try refreshing the page.",
      {
        position: "top-right",
      }
    );

  useEffect(() => {
    document.title = "BeatAI - Lex Chat";
  }, []);
  const [fetchingEvents, setFetchingEvents] = useState(false);
  const [events, setEvents] = useState([]);
  const [show, setShow] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputPosition, setInputPosition] = useState("bottom"); // 'centered' or 'bottom'
  const history = useHistory();
  const [userLocation, setUserLocation] = useState("");
  const [msg, setAIMsg] = useState("");
  const [message, setMessage] = useState("");
  const [messageAI, setMessageAI] = useState("");
  const scrollContainerRef = useRef(null);
  const [ftch, setFtch] = useState(false);
  const [chatActv, setChatActv] = useState(false);
  const [currChatId, setChatId] = useState(null);
  const [chatsHistory, setChatsHistory] = useState([]);
  const { chatId } = useParams();
  const verified = localStorage.getItem("verified");
  const [resendingMail, setResendingMail] = useState(false);
  const { firstname, lastname } = useUserProfile();
  const [weatherConditionCode, setWeatherConditionCode] = useState(false);
  const [isDay, setIsDay] = useState(true);
  const [model, setModel] = useState(localStorage.getItem("model") || "openai");
  const [uploading, setUploading] = useState([]);
  const [lastMessageId, setLastMessageID] = useState(null);
  const [loadingChats, setLoadingChats] = useState(false);
  const [searchInternet, setSearchInternet] = useState(false);
  const [typingState, setTypingState] = useState("Analyzing");
  const [isThinking, setIsThinking] = useState(false);
  const [navigatingEvent, setNavigatingEvent] = useState({
    eventObject: {},
    open: false,
  });
  const [currentPlan, setCurrentPlan] = useState(() => { // Add state for current plan
    try {
      const saved = localStorage.getItem('current_plan');
      return saved ? JSON.parse(saved) : { plan_id: 1, text: 'free' };
    } catch (e) {
      return { plan_id: 1, text: 'free' }; // Default to free if parsing fails
    }
  });
  const [is_premium, setIsPremium] = useState(currentPlan.text !== 'free'); // Add is_premium state

  const { isConnected, emit, subscribe, unsubscribe } = useSocket(
    localStorage.getItem("accessToken")
  );

  useEffect(() => { // Update is_premium when currentPlan changes (e.g., after login or plan update)
    const plan = localStorage.getItem('current_plan');
    try {
      const parsedPlan = plan ? JSON.parse(plan) : { plan_id: 1, text: 'free' };
      setCurrentPlan(parsedPlan);
      setIsPremium(parsedPlan.text !== 'free');
    } catch (e) {
      setCurrentPlan({ plan_id: 1, text: 'free' });
      setIsPremium(false);
    }
  }, []); // Consider adding dependencies if plan can change dynamically without page reload

  const modelChangeToast = (txt) =>
    toast(txt, {
      position: "top-right",
    });

  // Add a toast for premium features
  const premiumFeatureToast = () =>
    toast.info("This feature requires a Pro or Platinum plan. Please upgrade your membership.", {
      position: "top-right",
    });

  useEffect(() => {
    // Check if the selected model is premium and if the user is not premium
    const selectedModelIsPremium = ['xai', 'claude'].includes(model);
    if (selectedModelIsPremium && !is_premium) {
      setModel('openai'); // Revert to default free model
      localStorage.setItem('model', 'openai');
      toast.warn("Premium model selected. Switched back to default model. Please upgrade for premium features.", {
        position: "top-right",
      });
    }
     // Disable searchInternet if not premium
     if (!is_premium && searchInternet) {
        setSearchInternet(false);
        toast.info("Internet search requires a Pro or Platinum plan.", { position: "top-right" });
     }
  }, [model, is_premium]); // Add is_premium dependency

  useEffect(() => {
    setFetchingEvents(true);
    getDefaultEvents(new Date().toISOString())
      .then((e) => {
        setFetchingEvents(false);
        setEvents(e);
      })
      .catch((e) => {
        setFetchingEvents(false);
        failureFetchEvents();
      });
  }, []);

  useEffect(() => {
    fetch(API_BASE_URL + "/get_location/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
      .then(async (r) => {
        const d = await r.json();
        let city = d["city"]["name"];
        let country = d["country"]["name"];
        let subdiv = null;
        try {
          subdiv = d["subdivision"]["name"];
          setWeatherConditionCode(d.weather_code);
          setIsDay(d.is_day);
        } catch (e) {}

        setUserLocation(
          `${city ? city : ""}${
            city && city.length > 0 && country && country.length > 0 ? ", " : ""
          }${subdiv && country == "United States" ? subdiv : country}`
        );
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    if (chatId) {
      setChatActv(true);
      setLoadingChats(true);
      getChatMessages(chatId.split("_")[1])
        .then((chMessages) => {
          setLoadingChats(false);

          const updMessages = chMessages.map((m) => {
            let isWeather = false;
            let isNavRoute = false;
            let isECharts = false;
            let isEvents = false;
            let isStockQ = false;
            let isNews = false;
            let isDateAndTime = false;
            let isInternetSearch = false;
            let isDefault = true;
            let json_ = "";

            if (m.content.startsWith("beatai_sys_json===")) {
              const chunk_json_parts = m.content.split("===");
              const tool_ = chunk_json_parts[1];
              json_ = JSON.parse(chunk_json_parts[2]);

              switch (tool_) {
                case "get_weather":
                  isWeather = true;
                  break;
                case "make_charts":
                  isECharts = true;
                  break;
                case "get_stock_quote":
                  isStockQ = true;
                  break;
                case "get_navigation_route":
                  isNavRoute = true;
                  break;
                case "search_event":
                  isEvents = true;
                  break;
                case "get_time_date_by_location":
                  isDateAndTime = true;
                  break;
                case "get_news":
                  isNews = true;
                  break;
                case "internet_search":
                  isInternetSearch = true;
                  break;
                default:
                  isDefault = true;
              }

              return {
                ...m,
                isWeather,
                isECharts,
                isDateAndTime,
                isNavRoute,
                isDefault,
                isNews,
                isStockQ,
                isEvents,
                isInternetSearch,
                json_,
              };
            } else {
              return {
                ...m,
                isDefault,
              };
            }
          });
          setMessages(updMessages);
          setTypingState("Analyzing");
        })
        .catch((res) => {
          setLoadingChats(false);

          if (res.message == "not_found") {
            notFoundChat();
            setTimeout(() => {
              history.push("/chat");
            }, 5000);
          }
        });
    } else {
      setChatActv(false);
      setMessages([]);
      setTypingState("Analyzing");

      setAIMsg("");
      setFtch(false);
      setChatId(null);
      setMessage("");
    }
  }, [chatId]);

  useEffect(() => {
    getChats().then((chats) => {
      setChatsHistory(chats);
    });
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    if (ftch) {
      setMessages([
        {
          content: "",
          is_user_message: false,
          type: "TEXT",
          created_at: new Date().toString(),
          ai_model_id: model,
          attachements: [],
        },
        ...messages,
      ]);
      setTypingState("Analyzing");

      const fetchResponseStream = async () => {
        try {
          const response = await fetch(`${API_BASE_URL}/api/stream/`, {
            method: "POST",
            body: JSON.stringify({
              user_message: messageAI,
              chat_id: currChatId,
              user_datetime: new Date().toISOString(),
              provider: model,
              search_internet: searchInternet,
              search_local_sources: localStorage.getItem("pref:scan_local_source") === "1" ? true: false,
            }),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            signal: abortController.signal,
          });

          if (!response.ok) {
            if (response.status == 400) {
              const r = await response.json();
              if (r.account) {
                alert(
                  "Account is not verified! Please check your email and spam folders."
                );
              }
            }
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder("utf-8");
          let isWeather = false;
          let isECharts = false;
          let isNavRoute = false;
          let isStockQ = false;
          let isEvents = false;
          let isNews = false;
          let isDateAndTime = false;
          let isDefault = true;
          let json_ = "";
          let txt = "";
          let isInternetSearch = false;
          let jsonError = false;

          while (true) {
            const { done, value } = await reader.read();

            const chunk = decoder.decode(value);

            if (!chunk.startsWith("beatai_sys_json===")) {
              debugger
              setAIMsg((prev) => prev + chunk);

              if (msg.length === 0 && chunk === "<think>") {
                setIsThinking(true);
              }

              if (isThinking && chunk == "</think>") {
                setIsThinking(false);
              }
            }

            

            txt = txt + chunk;

            if (done) {
              if (txt.includes("beatai_sys_json===")) {
                try {
                  const chunk_json_parts = txt.split("===");
                  const tool_ = chunk_json_parts[chunk_json_parts.length - 2];

                  switch (tool_) {
                    case "get_weather":
                      isWeather = true;
                      break;
                    case "make_charts":
                      isECharts = true;
                      break;
                    case "get_stock_quote":
                      isStockQ = true;
                      break;
                    case "get_navigation_route":
                      isNavRoute = true;
                      break;
                    case "search_event":
                      isEvents = true;
                      break;
                    case "get_time_date_by_location":
                      isDateAndTime = true;
                      break;
                    case "get_news":
                      isNews = true;
                      break;
                    case "internet_search":
                      isInternetSearch = true;
                      break;
                    default:
                      isDefault = true;
                  }

                  json_ = JSON.parse(
                    chunk_json_parts[chunk_json_parts.length - 1]
                  );
                  txt = `beatai_sys_json===${tool_}===${
                    chunk_json_parts[chunk_json_parts.length - 1]
                  }`;
                } catch (e) {
                  console.log("STREM ER", e);
                }
              }
              break;
            }
          }

          console.log(txt);

          addMessageToChat(currChatId, {
            content: txt,
            type: "TEXT",
            ai_model_id: model,
            attachements: [],
          }).catch((e) => {
            console.log(e);
            alert("There was a network issue, please try again later.");
          });
          setMessages([
            ...messages,
            {
              isNews,
              isDateAndTime,
              isWeather,
              isECharts,
              isNavRoute,
              isDefault,
              isStockQ,
              isEvents,
              isInternetSearch,
              json_,
              content: txt,
              message_type: "TEXT",
              is_user_message: false,
              created_at: new Date().toString(),
              ai_model_id: model,
            },
          ]);
          setTypingState("Analyzing");

          setAIMsg("");

          setFtch(false);
        } catch (error) {
          console.error("Error fetching response stream:", error.message);
          setFtch(false);
        }
      };

      fetchResponseStream();
    }

    return () => {
      abortController.abort();
    };
  }, [ftch]);

  useEffect(() => {
    if (ftch || messages.length > 0)
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop =
          scrollContainerRef.current.scrollHeight;
      }
  }, [ftch, messages, msg]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    history.push("/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R");
  };

  const searchInternetOn = (content) =>
    toast.info(content, {
      position: "top-right",
    });

  useEffect(() => {
    if (searchInternet) {
      searchInternetOn("Using Internet for Queries.");
    }
  }, [searchInternet]);

  const initChat = async () => {
    if (ftch) {
      return;
    }

    const m = `${message}`;
    setMessageAI(m);
    setMessage("");
    setChatActv(true);
    setAIMsg("");

    const uploadFailToast = (content) =>
      toast.error(content, {
        position: "top-right",
      });

    if (!chatId) {
      await createChat({ title: m.substring(0, 50) + "..." })
        .then((chatObject) => {
          history.push(`/chat/${chatObject.uuid}_${chatObject.id}/`);
          setChatId(chatObject.id);
          setChatsHistory([
            {
              id: chatObject.id,
              title: chatObject.title,
              created_at: chatObject.created_at,
              uuid: chatObject.uuid,
            },
            ...chatsHistory,
          ]);
          return chatObject.id;
        })
        .then(async (id) => {
          await addMessageToChat(id, {
            content: m,
            message_type: "TEXT",
            ai_model_id: model,
            is_user_message: true,
            attachements: [],
          })
            .then(async (c) => {
              setLastMessageID(c.id);
              let attachementsUploadSuccess = false;
              let attchThumbs = {};

              await Promise.all(
                files.map(async (f) => {
                  const uploadingNew = uploading;

                  uploadingNew.push(f.id);
                  setUploading(uploadingNew);
                  await addAttachementToChat(f.file, c.id)
                    .then(async (r) => {
                      if (!r.ok) {
                        throw new Error();
                      }
                      const j = await r.json();
                      setUploading((prev) => prev.filter((x) => x != f.id));
                      setFiles((prev) => prev.filter((x) => x.id != f.id));
                      attchThumbs[f.id] = j.data.url;
                    })
                    .catch(() => {
                      uploadFailToast(`Couldn't upload ${f.file.name}`);
                      setFiles((prev) => prev.filter((x) => x.id != f.id));
                      setUploading((prev) => prev.filter((x) => x != f.id));
                    });
                })
              ).then(() => {
                attachementsUploadSuccess = true;
              });

              setMessages([
                ...messages,
                {
                  content: m,
                  message_type: "TEXT",
                  is_user_message: true,
                  created_at: new Date().toString(),
                  isDefault: true,
                  attachements:
                    attachementsUploadSuccess && files.length
                      ? files.map((f) => {
                          return {
                            original_name: f.file.name,
                            id: f.id,
                            url: attchThumbs[f.id],
                            mime_type: f.content_type,
                          };
                        })
                      : [],
                },
              ]);
              setTypingState("Analyzing");

            })
            .catch((e) => {
              debugger;
              console.log(e);
              alert("There was a network issue, please try again later.");
            });
          setFtch(true);
        });
    } else {
      setChatId(parseInt(chatId.split("_")[1]));
      await addMessageToChat(parseInt(chatId.split("_")[1]), {
        content: m,
        message_type: "TEXT",
        ai_model_id: model,
        is_user_message: true,
        attachements: [],
      })
        .then(async (c) => {
          setLastMessageID(c.id);

          let attachementsUploadSuccess = false;
          let attchThumbs = {};

          await Promise.all(
            files.map(async (f) => {
              const uploadingNew = uploading;
              uploadingNew.push(f.id);
              setUploading(uploadingNew);
              await addAttachementToChat(f.file, c.id)
                .then(async (r) => {
                  if (!r.ok) {
                    throw new Error();
                  }
                  const j = await r.json();

                  attchThumbs[f.id] = j.data.url;
                  setUploading((prev) => prev.filter((x) => x != f.id));
                  setFiles((prev) => prev.filter((x) => x.id != f.id));
                })
                .catch(() => {
                  uploadFailToast(`Couldn't upload ${f.file.name}`);
                  setUploading((prev) => prev.filter((x) => x != f.id));
                  setFiles((prev) => prev.filter((x) => x.id != f.id));
                });
            })
          ).then(() => {
            attachementsUploadSuccess = true;
          });

          setMessages([
            ...messages,
            {
              content: m,
              message_type: "TEXT",
              is_user_message: true,
              created_at: new Date().toString(),
              isDefault: true,
              attachements:
                attachementsUploadSuccess && files.length
                  ? files.map((f) => {
                      return {
                        original_name: f.file.name,
                        id: f.id,
                        mime_type: f.content_type,
                        url: attchThumbs[f.id],
                      };
                    })
                  : [],
            },
          ]);
        })
        .catch((e) => {
          console.log(e);
          alert("There was a network issue, please try again later.");
        });
      setFtch(true);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (message.trim()) {
        setShowSuggestions(false);
        initChat();
      }
    }
  };

  const getGreet = () => {
    const now = new Date();
    const hours = now.getHours();
    let greeting;

    if (hours >= 5 && hours < 12) {
      greeting = (
        <>
          <WeatherIcon
            localDayTime={true}
            isDay={isDay}
            code={weatherConditionCode}
          />{" "}
          Good Morning
        </>
      );
    } else if (hours >= 12 && hours < 18) {
      greeting = (
        <>
          <WeatherIcon
            localDayTime={true}
            isDay={isDay}
            code={weatherConditionCode}
          />{" "}
          Good Afternoon
        </>
      );
    } else if (hours >= 18 && hours < 22) {
      greeting = (
        <>
          <WeatherIcon isDay={isDay} code={weatherConditionCode} /> Good Evening
        </>
      );
    } else {
      return (
        <>
          <WeatherIcon isDay={isDay} code={weatherConditionCode} /> Good Evening
        </>
      );
    }

    return greeting;
  };

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const suggBoxRef = useRef(null);
  const [chatRemConfirmID, setChatRemConfirmID] = useState(null);
  const [deletingChat, setDeletingChat] = useState(false);

  const handleClickOutsideSugg = (event) => {
    if (suggBoxRef.current && !suggBoxRef.current.contains(event.target)) {
      setShowSuggestions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideSugg);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideSugg);
    };
  }, []);

  const getSuggestions = useDebouncedCallback(() => {
    autoSuggest(message)
      .then((res) => {
        if (ftch) return;
        if (!ftch) setShowSuggestions(true);
        setSuggestions(res.suggestions);
      })
      .catch((e) => {
        setShowSuggestions(false);
      });
  }, 500);

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      style={{
        textDecoration: "none",
      }}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));

  const customAccordionStyle = {
    border: "none !important",
    backgroundColor: "rgba(180, 71, 223, 0.09) !important",
    color: "white !important",
  };

  const customHeaderStyle = {
    backgroundColor: "rgba(180, 71, 223, 0.09) !important",
    color: "white !important",
    border: "none !important",
    fontSize: "0.8em !important",
  };

  const offCanvRef = useRef(null);

  // Scroll to bottom
  const offCanvScrollBottom = () => {
    if (offCanvRef.current) {
      offCanvRef.current.scrollTop = offCanvRef.current.scrollHeight;
    }
  };

  const { setAvatarB64, getAvatarB64 } = useAvatar();
  const [avatarB64Local, setAvatarB64Local] = useState(null);
  const [changingAvatar, setChangingAvatar] = useState(false);

  const handleFileChange = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];

    // Validate file type (JPEG/PNG)
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      alert("Only JPEG and PNG formats are allowed.");
      return;
    }

    try {
      setChangingAvatar(true);
      await changeAvatar(file);
      alert("Avatar updated successfully!");

      // Fetch and update the base64 image in the hook state
      const avatar = await getAvatarB64(true);
      setAvatarB64Local(avatar);
      setChangingAvatar(false);
    } catch (error) {
      alert(error.message);
      setChangingAvatar(false);
    }
  };
  useEffect(() => {
    setChangingAvatar(true);

    getAvatarB64()
      .then((avatar) => {
        setChangingAvatar(false);
        setAvatarB64Local(avatar);
      })
      .catch((e) => {
        setChangingAvatar(false);
      });
  }, []);

  const uploadAvatarRef = useRef(null);

  const [searchFocused, setSearchFocused] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchingChats, setSearchingChats] = useState(false);
  const [chatSearchResults, setChatSearchResults] = useState(null);

  const handleFocus = () => setSearchFocused(true);
  const handleBlur = () => !searchText && setSearchFocused(false);

  const handleClear = () => {
    setSearchText("");
    setChatSearchResults(null);
    setSearchFocused(false);
  };

  const getSearchResultMessageTxt = (txt) => {
    const isEvent = txt.includes("beatai_sys_json===search_event");
    const isWeather = txt.includes("beatai_sys_json===get_weather");
    const isECharts = txt.includes("beatai_sys_json===make_charts");
    const isStock = txt.includes("beatai_sys_json===get_stock_quote");
    const isNews = txt.includes("beatai_sys_json===get_news");
    const isTime = txt.includes("beatai_sys_json===get_time_date_by_location");
    const isInternetSearch = txt.includes("beatai_sys_json===internet_search");
    const isNavRoute = txt.includes("beatai_sys_json===get_navigation_route");

    if (isEvent) {
      return "<Queried Events>";
    }
    if (isWeather) {
      return "<Queried Weather>";
    }
    if (isECharts) {
      return "<Queried Data Visualisation>";
    }
    if (isStock) {
      return "<Queried Stock Quote>";
    }
    if (isNews) {
      return "<Searched News>";
    }
    if (isTime) {
      return "<Searched Time>";
    }
    if (isInternetSearch) {
      return "<Searched Internet>";
    }
    if (isNavRoute) {
      return "<Route Calculation>"
    }

    return txt.length > 200 ? txt.slice(0, 200) + "..." : txt;
  };

  const CodeBlock = ({ className, children }) => {
    let lang = "text"; // default monospaced text
    if (className && className.startsWith("lang-")) {
      lang = className.replace("lang-", "");
    }
    return (
      <SyntaxHighlighter language={lang} style={CodeStyle}>
        {children}
      </SyntaxHighlighter>
    );
  };

  // markdown-to-jsx uses <pre><code/></pre> for code blocks.
  const PreBlock = ({ children, ...rest }) => {
    if ("type" in children && children["type"] === "code") {
      return CodeBlock(children["props"]);
    }
    return <pre {...rest}>{children}</pre>;
  };

  const [showModelComparison, setShowModelComparison] = useState(false);

  const getModelName = (provider) => {
    switch (provider) {
      case "openai":
        return "OpenAI GPT-4o";
      case "gemini":
        return "Gemini 2.0 Flash";
      case "xai":
        return "Grok - Beta";
      case "claude":
        return "Claude 3.7 Sonnet";
      case "deepseekr1":
        return "DeepSeek R1";
      case "qwenvmax":
        return "Qwen-VL-Max";
      default:
        return "";
    }
  };

  const getSupportedFormats = (provider) => {
    switch (provider) {
      case "openai":
        return ["jpeg", "png", "gif", "pdf", "csv", "txt", "pdf"];
      case "xai":
        return ["jpeg", "png", "gif"];
      case "claude":
        return ["jpeg", "png", "gif", "pdf"];
      case "deepseekr1":
        return []
      case "qwenvmax":
        return ["jpeg", "png", "gif"]
      default:
        return [
          "txt",
          "jpeg",
          "png",
          "gif",
          "pdf",
          "csv",
          "js",
          "py",
          "md",
          "html",
        ];
    }
  };

  const [files, setFiles] = useState([]);

  const generateThumbnail = useCallback(
    (file, id, size = 200, quality = 0.8) => {
      return new Promise((resolve, reject) => {
        if (!file.type.startsWith("image/")) {
          reject("Invalid file type");
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const img = document.createElement("img");
          img.onload = () => {
            // Create square canvas
            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext("2d");

            // Enable image smoothing
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";

            // Calculate dimensions for center crop
            let sourceX = 0;
            let sourceY = 0;
            let sourceWidth = img.width;
            let sourceHeight = img.height;

            if (sourceWidth > sourceHeight) {
              sourceX = (sourceWidth - sourceHeight) / 2;
              sourceWidth = sourceHeight;
            } else {
              sourceY = (sourceHeight - sourceWidth) / 2;
              sourceHeight = sourceWidth;
            }

            // Draw center-cropped and resized image
            ctx.drawImage(
              img,
              sourceX,
              sourceY,
              sourceWidth,
              sourceHeight,
              0,
              0,
              size,
              size
            );

            // Convert to blob
            canvas.toBlob(
              (blob) => {
                const thumbnailUrl = URL.createObjectURL(blob);

                setFiles((prev) =>
                  prev.map((x) =>
                    x.id == id ? { ...x, thumb: thumbnailUrl } : x
                  )
                );

                resolve(thumbnailUrl);
              },
              "image/jpeg",
              quality
            );
          };

          img.onerror = () => {
            reject("Image loading failed");
          };

          img.src = e.target.result;
        };

        reader.onerror = () => {
          reject("File reading failed");
        };

        reader.readAsDataURL(file);
      });
    },
    []
  );

  const cleanup = useCallback(() => {
    files.map((x) => {
      if (x.thumb) {
        URL.revokeObjectURL(x.thumb);
      }
    });
  }, [files]);

  React.useEffect(() => {
    return cleanup;
  }, [cleanup]);

  useEffect(() => {
    setFiles([]);
  }, []);

  function generateUniqueId() {
    const timestamp = Date.now(); // Current timestamp in milliseconds
    const randomNumber = Math.random().toString(36).substring(2, 8); // Generate a random string
    return `file_${timestamp}_${randomNumber}`; // Combine timestamp and random string
  }

  const allowedTypes =
    model == "openai"
      ? [
          "image/jpeg",
          "image/png",
          "image/gif",
          "application/pdf",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "text/csv",
          "text/plain",
          "text/x-php",
          "text/x-python",
          "text/x-java",
          "text/x-csrc",
          "text/x-c++src",
          "text/x-sql",
          "text/javascript",
        ]
      : model == "xai"
      ? ["image/jpeg", "image/png", "image/gif"]
      : model == "claude"
      ? ["image/jpeg", "image/png", "image/gif", "application/pdf"]
      : model == "deepseekr1"? []: model=="qwenvmax"? [
        "image/jpeg",
          "image/png",
          "image/gif",
          "video/mp4",
      ] : [
          "text/plain",
          "image/jpeg",
          "image/png",
          "image/gif",
          "application/pdf",
          "text/csv",
          "text/javascript",
          "text/python",
          "text/markdown",
          "text/html",
        ];

  const handleAttachementSelect = (e) => {
    if (!is_premium) {
      premiumFeatureToast();
      return; // Prevent file selection for non-premium users
    }
    // ... rest of the existing handleAttachementSelect logic ...
    const selectedFiles = Array.from(e.target.files)
      .filter((file) => allowedTypes.includes(file.type))
      .map((f) => {
        return {
          file: f,
          id: generateUniqueId(),
        };
      });

    if (selectedFiles && selectedFiles.length > 0) {
      if (selectedFiles.length + files.length > 10) {
        alert("You can only upload 10 files at a time");
        return; // Added return
      }

      let newFiles = [...files];

      selectedFiles.map((f) => {
        const existing = newFiles.filter(
          (nf) => nf.file.lastModified == f.file.lastModified
        );
        if (Array.isArray(existing) && existing.length > 0) return; // Added return
        newFiles.push(f);
      });

      newFiles.reverse();
      setFiles(newFiles);
      newFiles.map((f) => {
        generateThumbnail(f.file, f.id).catch(() => {});
      });
    } else {
      // ... existing else logic ...
      if (model == "openai" || model == "claude") {
        alert("Please select valid file types (JPEG, WebP, PDFs)");
      } else if (model == "xai") {
        alert("Please select valid file types (JPEG, WebP)");
      } else {
        alert("Please select valid file types"); // Generic message
      }
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
    if (!is_premium) {
      premiumFeatureToast();
      return; // Prevent file drop for non-premium users
    }
    // ... rest of the existing handleDrop logic ...
    const selectedFiles = Array.from(e.dataTransfer.files)
      .filter((file) => allowedTypes.includes(file.type))
      .map((f) => {
        return {
          file: f,
          id: generateUniqueId(),
        };
      });

    if (selectedFiles && selectedFiles.length > 0) {
      if (selectedFiles.length + files.length > 10) {
        alert("You can only upload 10 files at a time");
        return;
      }

      let newFiles = [...files];
      selectedFiles.map((f) => {
        const existing = newFiles.filter(
          (nf) => nf.file.lastModified == f.file.lastModified
        );
        if (Array.isArray(existing) && existing.length > 0) return; // Added return
        newFiles.push(f);
      });
      newFiles.reverse();
      setFiles(newFiles);
      newFiles.map((f) => {
        generateThumbnail(f.file, f.id).catch(() => {});
      });
    } else {
      // ... existing else logic ...
      if (model == "openai" || model == "claude") {
        alert("Please select valid file types (JPEG, WebP, PDFs)");
      } else if (model == "xai") {
        alert("Please select valid file types (JPEG, WebP)");
      } else {
        alert("Please select valid file types"); // Generic message
      }
    }
  };

  const uploadAttachmentRef = React.useRef(null);

  const getFileIconFromExt = (filename) => {
    const ext = filename.split(".").pop();
    switch (ext) {
      case "jpg":
        return (
          <Image
            style={{
              maxWidth: "40px",
            }}
            src={imageFileIcon}
          />
        );
      case "png":
        return (
          <Image
            style={{
              maxWidth: "40px",
            }}
            src={imageFileIcon}
          />
        );
      case "gif":
        return (
          <Image
            style={{
              maxWidth: "40px",
            }}
            src={imageFileIcon}
          />
        );
      case "pdf":
        return (
          <Image
            style={{
              maxWidth: "40px",
            }}
            src={pdfFileIcon}
          />
        );
      case "xlsx":
        return (
          <Image
            style={{
              maxWidth: "40px",
            }}
            src={excelFileIcon}
          />
        );
      case "xls":
        return (
          <Image
            style={{
              maxWidth: "40px",
            }}
            src={excelFileIcon}
          />
        );
      case "csv":
        return (
          <Image
            style={{
              maxWidth: "40px",
            }}
            src={csvFileIcon}
          />
        );
      case "txt":
        return (
          <Image
            style={{
              maxWidth: "40px",
            }}
            src={textFileIcon}
          />
        );
      default:
        return (
          <Image
            style={{
              maxWidth: "40px",
            }}
            src={textFileIcon}
          />
        );
    }
  };

  const [isDraggingOver, setIsDraggingOver] = useState(false);

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="sm" className="w-100 m-0 nav_">
        <Container fluid className="">
          <input
            hidden
            ref={uploadAvatarRef}
            type="file"
            accept="image/jpeg,image/png"
            onChange={handleFileChange}
          />
          <Button
            variant="outline-light"
            onClick={handleShow}
            className="border-0"
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
          <Navbar.Brand
            className=""
            style={{ cursor: "pointer" }}
            title="+ Start new chat"
            onClick={(e) => history.push("/chat/")}
          >
            <Image src={Logo} style={{ maxWidth: "100px" }} />
          </Navbar.Brand>
          <Nav className="" style={{ width: "80%" }}>
            <Button className="model-sel-dd model-sel-toggle"
              onClick={() => {
                setShowModelComparison(true);
              }}
              size="sm"
            >
            <FontAwesomeIcon icon={faBars} />
          {" "}
            {(!model || model == "openai") && "OpenAI GPT-4o"}
                {model == "xai" && "xAI Grok - Beta"}
                {model == "claude" && "Claude 3.7 Sonnet"}
                {model == "gemini" && "Gemini 2.0 Flash"}
                {model == "deepseekr1" && "DeepSeek R1"}
                {model == "qwenvmax" && "Qwen-VL-Max"}
            </Button>
            <Nav.Link
              as={Link}
              to="/chat"
              className={
                window.location.href.indexOf("chat") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              Chat
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/ai-images/"
              className={
                window.location.href.indexOf("ai-image") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faMagicWandSparkles} /> AI Images
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/ai-workflows/"
              className={
                window.location.href.indexOf("ai-workflows") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faCompassDrafting} /> Workflows
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/beats"
              title="Coming Soon!"
              className={
                window.location.href.indexOf("beats") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faMusic} /> Beats
            </Nav.Link>
          </Nav>
          <Dropdown align="end" className="user-avatar-dropdown">
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
              <div className="user-avatar" style={{ textAlign: "center" }}>
                {!avatarB64Local &&
                  !changingAvatar &&
                  (firstname ? (
                    firstname[0]
                  ) : (
                    <FontAwesomeIcon icon={faPerson} />
                  ))}
                {!changingAvatar && avatarB64Local && (
                  <Avatar
                    base64Image={avatarB64Local}
                    width="30px"
                    height="30px"
                  />
                )}
                {changingAvatar && <Spinner size="sm" />}
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Container fluid>
                <Container className="text-center">
                  <div
                    className="user-avatar"
                    style={{ margin: "0 auto", width: "80px", height: "80px" }}
                    onClick={() => {
                      if (uploadAvatarRef.current) {
                        uploadAvatarRef.current.click();
                      }
                    }}
                  >
                    {!avatarB64Local &&
                      !changingAvatar &&
                      (firstname ? (
                        firstname[0]
                      ) : (
                        <FontAwesomeIcon icon={faPerson} />
                      ))}
                    {!changingAvatar && avatarB64Local && (
                      <Avatar
                        base64Image={avatarB64Local}
                        width="70px"
                        height="70px"
                      />
                    )}
                    {changingAvatar && <Spinner size="sm" />}
                  </div>
                  <br />
                  <p
                    style={{
                      fontSize: "0.7em",
                      color: "white",
                      margin: "0 auto",
                    }}
                  >
                    {firstname} {lastname}
                  </p>
                </Container>
              </Container>
              <Dropdown.Divider />
              <Dropdown.Item
                className="user-avt-dd-itm"
                onClick={() => {
                  if (uploadAvatarRef.current) {
                    uploadAvatarRef.current.click();
                  }
                }}
              >
                <FontAwesomeIcon icon={faUserEdit} className="me-2" /> Change
                Avatar
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
              >
                <Link
                  to="/membership"
                  style={{
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faIdBadge} className="me-2" />{" "}
                  Membership
                </Link>
              </Dropdown.Item>
              <Dropdown.Item className="user-avt-dd-itm">
                <Link
                  to="/account-settings"
                  style={{
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faShieldAlt} className="me-2" />{" "}
                  Account Settings
                </Link>
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
                onClick={() => {
                  window.open("https://beatbind.io/privacy", "_blank");
                }}
              >
                <FontAwesomeIcon className="me-2" icon={faLink} />
                <a
                  style={{
                    color: "white",
                  }}
                  href="https://beatbind.io/privacy"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </Dropdown.Item>
              <Dropdown.Item className="user-avt-dd-itm" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {verified === "false" ? (
            <i className="ms-auto">
              <Badge>Unverified</Badge>
            </i>
          ) : null}
        </Container>
      </Navbar>
      <Container >
        {resendingMail && (
          <>
            <Spinner size="sm" /> Resending mail
          </>
        )}
        {!resendingMail && verified === "false" && (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setResendingMail(true);
              resendVerification()
                .then(() => {
                  setResendingMail(false);
                  alert("Link sent!");
                })
                .catch((e) => {
                  setResendingMail(false);
                  alert("Couldn't send, please try again later!");
                });
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} />{" "}
            <u>Resend Verification Link</u>
          </span>
        )}
        <br />
        <Container 
        
        className="chat-container d-flex flex-column align-items-center">
          <Row className="w-200 py5 ppng greet-row">
            <p style={{ fontSize: "0.8em" }} className="ppngr greet-main">
              {userLocation.length > 0 && (
                <FontAwesomeIcon size="xs" icon={faLocationPin} />
              )}{" "}
              {userLocation} {userLocation ? " " : null}
              {"  "}
              <span style={{ marginLeft: "4px" }}>{getGreet()}</span>
            </p>
          </Row>
          <Row
            ref={scrollContainerRef}
            className={`message-row ${
              inputPosition === "bottom" ? "flex-grow-1" : ""
            }`}
            style={{
              marginBottom:
                showSuggestions && suggestions.length > 0 && message.length > 0
                  ? "10%"
                  : "5%",
            }}
            
          >
            <Col 
            
            className="p-0 d-flex flex-column">
              <div
                className="flex-grow-1 p-3"
                style={{
                  overflow: "hidden",
                }}
              >
                {loadingChats && (
                  <Col sm={12} md={12} xs={12} className="text-center">
                    <Spinner size="sm" /> Loading Messages...
                  </Col>
                )}
                {!chatActv && (
                  <Container>
                    <Row className="chat-header w-200 text-left py-3 ppn">
                      <h2 className="ppngr">
                        <MeetLex />
                      </h2>
                      <p>Friendly Advice. Anytime.</p>
                      <hr style={{ color: "grey", width: "30%" }} />
                    </Row>
                    <Row>
                      {fetchingEvents && (
                        <Col sm={12} md={12} xs={12} className="text-center">
                          <Spinner size="sm" />{" "}
                          <span
                            className="lex-color"
                            style={{ fontSize: "1.4em" }}
                          >
                            Lex
                          </span>{" "}
                          is fetching events
                        </Col>
                      )}
                      {loadingChats && (
                        <Col sm={12} md={12} xs={12} className="text-center">
                          <Spinner size="sm" /> Fetching Messages...
                        </Col>
                      )}
                      {events.length > 0 &&
                        events.map((e, i) => {
                          let imLink = "";
                          const fitImg = e.images
                            ? e.images.find((im) => im.ratio === "16_9")
                            : null;
                          if (!fitImg) {
                            if (e.images && e.images.length > 0) {
                              imLink = e.images[0];
                            } else {
                              imLink =
                                "https://www.beatai.io/assets/img/favicon.png";
                            }
                          } else {
                            imLink = fitImg["url"];
                          }

                          return (
                            <Col sm={3} md={3} xs={6} className="p-0 m-0">
                              <EventVenue
                                title={e.name}
                                city={e.venue_city}
                                country={e.venue_country}
                                classification={e.classification}
                                alink={e.url}
                                countryCode={e.country_code}
                                stateCode={e.state_code}
                                stateName={e.state_name || ""}
                                venue={e.venue_name + " " + e.venue_city}
                                time={
                                  new Date(e.start_date).toLocaleDateString() +
                                  " " +
                                  (e.start_time !== null
                                    ? formatTime(e.start_time)
                                    : "")
                                }
                                imglink={imLink}
                              />
                            </Col>
                          );
                        })}
                    </Row>
                  </Container>
                )}
                <div
                  className="message-container"
                  style={{
                    marginBottom: "30px",
                  }}
                >
                  {messages.map((ms, i) => {
                    const m = messages[i];
                    const attachements = m.attachements;

                    let msgComp = null;

                    if (m.isDefault) {
                      msgComp = (
                        <Markdown
                          options={{
                            overrides: {
                              img: {
                                props: {
                                  style: {
                                    maxWidth: "200px",
                                    margin: "20px 20px",
                                  },
                                },
                              },
                              h3: {
                                props: {
                                  style: {
                                    fontSize: "1.2em",
                                  },
                                },
                              },
                              h1: {
                                props: {
                                  style: {
                                    fontSize: "1.3em",
                                  },
                                },
                              },
                              pre: PreBlock,
                            },
                          }}
                        >
                          {!m.content.startsWith("beatai_sys_json===") &&
                            m.content}
                        </Markdown>
                      );
                    }

                    if (m.isWeather) {
                      msgComp = <WeatherMsg {...m.json_} />;
                    }

                    if (m.isECharts) {
                      msgComp = <ChartComponent charts={m.json_['charts']} summary={m.json_.summary} citations={m.json_.citations}/>
                    }

                    if (m.isNavRoute) {
                      msgComp = <EmbeddedChatMap source={m.json_.source} dest={m.json_.destination} />;
                    }

                    if (m.isStockQ) {
                      msgComp = <StockQuoteCard {...m.json_} />;
                    }

                    if (m.isDateAndTime) {
                      msgComp = <TimeLocationCard {...m.json_} />;
                    }

                    if (m.isNews) {
                      msgComp = <NewsCard {...m.json_} />;
                    }

                    if (m.isInternetSearch) {
                      msgComp = <InternetSearch {...m.json_} />;
                    }

                    if (m.isEvents) {
                      try {
                        const location_coords = m.json_.map((ev, i) => {
                          return { lat: ev.lat, lon: ev.lon };
                        });
                        msgComp = (
                          <Row
                            style={{ marginTop: "10px", marginBottom: "10px" }}
                          >
                            <Col sm={12} md={12} xs={12}>
                              {m.json_.length > 0
                                ? "Found these events:"
                                : "Sorry! There weren't any events during search!"}
                              <hr />
                            </Col>
                            {m.json_.map((e, i) => {
                              if (!(typeof e == "object")) {
                                throw new Error();
                              }
                              let imLink = "";
                              const fitImg = e.images
                                ? e.images.find((im) => im.ratio === "16_9")
                                : null;
                              if (!fitImg) {
                                if (e.images && e.images.length > 0) {
                                  imLink = e.images[0];
                                } else {
                                  imLink =
                                    "https://www.beatai.io/assets/img/favicon.png";
                                }
                              } else {
                                imLink = fitImg["url"];
                              }
                              return (
                                <Col
                                  sm={3}
                                  md={3}
                                  xs={6}
                                  style={{ marginBottom: "7px" }}
                                  className="mt-2"
                                >
                                  <QueryResultEventCard
                                    country={e.venue_country}
                                    city={e.venue_city}
                                    title={e.name}
                                    alink={e.url}
                                    countryCode={e.country_code}
                                    stateCode={e.state_code}
                                    stateName={e.state_name}
                                    classification={e.classification}
                                    venue={e.venue_name + " " + e.venue_city}
                                    time={
                                      new Date(
                                        e.start_date
                                      ).toLocaleDateString() +
                                      " " +
                                      (e.start_time !== null
                                        ? formatTime(e.start_time)
                                        : "")
                                    }
                                    imglink={imLink}
                                  />
                                </Col>
                              );
                            })}
                            {location_coords.length > 0 && (
                              <Col sm={12} md={12} xs={12}>
                                <APIProvider
                                  apiKey={MAP_KEY}
                                  onLoad={() =>
                                    console.log("Maps API has loaded.")
                                  }
                                >
                                  <Map
                                    navigateEvent={(locIdex) =>
                                      setNavigatingEvent({
                                        open: true,
                                        eventObject: m.json_[locIdex],
                                      })
                                    }
                                    nameList={m.json_.map(e => e.name)}
                                    className="m-4"
                                    locations={location_coords}
                                  />{" "}
                                </APIProvider>
                              </Col>
                            )}
                          </Row>
                        );
                      } catch (e) {
                        console.log(e)
                        return (
                          <div key={i.toString()} className="message">
                            <div
                              className={
                                m.is_user_message
                                  ? "identity_user"
                                  : "identity_lex"
                              }
                            >
                              <b>
                                {m.is_user_message ? (
                                  firstname ? (
                                    <>
                                      <Avatar
                                        base64Image={avatarB64Local}
                                        width={"10px"}
                                        height={"10px"}
                                      />
                                      {firstname}:
                                    </>
                                  ) : (
                                    "User:"
                                  )
                                ) : (
                                  "Lex:"
                                )}
                              </b>
                            </div>{" "}
                            <p style={{ color: "grey", fontSize: "0.7em" }}>
                              {!m.is_user_message && (
                                <b>{getModelName(m.ai_model_id)} </b>
                              )}
                              {new Date(m.created_at).toLocaleTimeString()}
                            </p>
                            <i style={{ color: "#db7d76", fontSize: "0.7em" }}>
                              {"Failure Analyzing this messaging"}
                            </i>
                          </div>
                        );
                      }
                    }

                    return (
                      <>
                        <div
                          key={i.toString()}
                          className="message"
                          style={{
                            marginTop: "4px",
                          }}
                        >
                          <div
                            className={
                              m.is_user_message
                                ? "identity_user"
                                : "identity_lex"
                            }
                          >
                            <b>
                              {m.is_user_message ? (
                                firstname ? (
                                  <>
                                    <span>
                                      {!avatarB64Local &&
                                        !changingAvatar &&
                                        (firstname ? (
                                          firstname[0]
                                        ) : (
                                          <FontAwesomeIcon icon={faPerson} />
                                        ))}
                                      {!changingAvatar && avatarB64Local && (
                                        <Avatar
                                          base64Image={avatarB64Local}
                                          width="20px"
                                          height="20px"
                                        />
                                      )}
                                      {changingAvatar && <Spinner size="sm" />}
                                    </span>
                                    <span style={{ display: "inline" }}>
                                      {" "}
                                      {firstname}:
                                    </span>
                                  </>
                                ) : (
                                  "User:"
                                )
                              ) : (
                                "Lex:"
                              )}
                            </b>
                          </div>{" "}
                          <p
                            style={{
                              color: "grey",
                              fontSize: "0.7em",
                              marginTop: "1px",
                            }}
                          >
                            {!m.is_user_message && (
                              <b>{getModelName(m.ai_model_id)}</b>
                            )}{" "}
                            {new Date(m.created_at).toLocaleTimeString()}
                          </p>
                          {msgComp}
                        </div>
                        {attachements && attachements.length > 0 && (
                          <Container>
                            <Row>
                              {attachements.map((a, i) => {
                                return (
                                  <Col
                                    title={a.original_name}
                                    className="m-2 attachment-chat"
                                    sm={3}
                                    xs={12}
                                    style={{
                                      borderRadius: "5px",
                                      backgroundColor:
                                        "rgba(130, 47, 168, 0.2)",
                                      padding: "3px 3px",
                                    }}
                                  >
                                    <span>
                                      {a.url && a.url.length > 0 ? (
                                        <span
                                          style={{
                                            borderRadius: "8px !important",
                                          }}
                                          className="w-10 h-10 overflow-hidden rounded-xl"
                                        >
                                          <Image
                                            src={a.url}
                                            className="object-cover object-center w-full h-full"
                                            width={40}
                                            height={40}
                                            style={{
                                              borderRadius: "8px",
                                              marginRight: "4px",
                                            }}
                                          />
                                        </span>
                                      ) : (
                                        getFileIconFromExt(a.original_name)
                                      )}{" "}
                                      {a.original_name &&
                                      a.original_name.length > 20
                                        ? a.original_name.substring(0, 14) +
                                          "..."
                                        : a.original_name}{" "}
                                    </span>
                                    <span
                                      className="float-sm-end"
                                      style={{
                                        marginRight: "5px",
                                        marginTop: "10px",
                                        opacity: "0.6",
                                        color: "#d9d9d9",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        className="float-sm-end"
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        icon={faCloudDownloadAlt}
                                        onClick={() => {
                                          downloadAttachment(a.server_name);
                                        }}
                                      />
                                    </span>
                                  </Col>
                                );
                              })}
                            </Row>
                          </Container>
                        )}
                      </>
                    );
                  })}
                  {ftch && (
                    <p>
                      <b>
                        <Spinner size="sm" animation="grow" />{" "}
                        <span className="lex-color" style={{ fontSize: "1em" }}>
                          Lex
                        </span>
                      </b>{" "}
                      <span className="shine">is {!isThinking && typingState}{isThinking?"Reasoning": ""}</span>
                    </p>
                  )}
                  {!msg.startsWith("beatai_sys_json===") && (
                    <>
                      <Markdown
                        // rehypePlugins={[rehypeRaw, remarkGfm]}
                        // className={"react-mdn"}
                        // components={{
                        //   h1: "h3",
                        //   h2: "h4",
                        //   h3: "h5",
                        // }}
                        
                        options={{

                          overrides: {
                            pre: PreBlock,
                            h3: {
                              props: {
                                style: {
                                  fontSize: "0.9em",
                                },
                              },
                            },
                            p: {
                             props: {
                              style: isThinking? {
                                  color: "#8b8ba7",
                                  fontStyle: "italic",
                                  fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
                              }: {}
                             }
                            },
                            think: {
                              props: {
                                style: {
                                  color: "#8b8ba7"
                                }
                              }
                            }
                          },
                        }}
                      >
                        {msg}
                      </Markdown>
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Form
            className={`message-form ${inputPosition}`}
            onDrop={handleDrop}
            onDragOver={(e) => {
              e.preventDefault();
              if (is_premium) { // Only show dragging effect for premium
                 setIsDraggingOver(true);
              }
            }}
            onDragLeave={() => setIsDraggingOver(false)}
            style={
              isDraggingOver && is_premium // Only apply style if premium
                ? {
                    border: "1px dashed #ccc",
                    cursor: "copy",
                  }
                : {}
            }
          >
            {message.length > 0 &&
              !ftch &&
              suggestions.length > 0 &&
              showSuggestions && (
                <div ref={suggBoxRef} className="suggestions-popup">
                  {suggestions.map((suggestion, index) => (
                    <span
                      key={index}
                      className="suggestion-item"
                      onClick={() => setMessage(suggestion)}
                    >
                      {suggestion}
                    </span>
                  ))}
                </div>
              )}
            {files.length > 0 && (
              <>
                {" "}
                <div
                  style={{
                    margin: 0,
                    padding: 0,
                    marginBottom: "10px",
                    display: "inline-block",
                    gap: "10px",
                    fontSize: "0.7em",
                    listStyle: "none",
                    width: "100%",
                    orverflowX: "auto",
                  }}
                >
                  {files.map((f, index) => (
                    <div
                      title={f.file.name}
                      style={{
                        cursor: "default",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        border: "1px solid #d9d9d9",
                        padding: "2px 8px",
                        borderRadius: "5px",
                        backgroundColor: "rgba(256, 256, 256, 0.09)",
                        whiteSpace: "nowrap",
                        margin: "5px",
                        width: "240px", // Adjust as needed
                      }}
                      key={f.id}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          overflow: "hidden",
                        }}
                      >
                        {!f.thumb && getFileIconFromExt(f.file.name)}{" "}
                        {f.thumb && (
                          <Image
                            key={f.id}
                            style={{
                              maxWidth: "40px",
                              margin: "2px",
                              borderRadius: "7px",
                            }}
                            src={f.thumb}
                          />
                        )}{" "}
                        <span
                          style={{
                            marginLeft: "5px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {f.file.name && f.file.name.length > 23
                            ? f.file.name.substring(0, 20) + "..."
                            : f.file.name}
                        </span>
                      </div>
                      {uploading.indexOf(f.id) === -1 ? (
                        <FontAwesomeIcon
                          style={{
                            cursor: "pointer",
                            backgroundColor: "grey",
                            borderRadius: "50%",
                            padding: "2px 2.5px",
                            marginLeft: "10px",
                          }}
                          size="xs"
                          icon={faClose}
                          onClick={() => {
                            setFiles((prev) =>
                              prev.filter((x) => x.id !== f.id)
                            );
                          }}
                        />
                      ) : (
                        <FontAwesomeIcon icon={faSpinner} />
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
            <Form.Group className="d-flex align-items-center w-300" style={{
              maxHeight: "100px",
              overflow: "hidden",
            }}>
              <OverlayTrigger
                placement={"top"}
                overlay={
                  <Tooltip
                    className="tooltp"
                    id={`tooltip-top-file-type`}
                    style={{
                      borderRadius: "10px",
                    }}
                  >
                    {model !== "deepseekr1" && is_premium && <Container // Check is_premium
                      style={{
                        textAlign: "left",
                        color: "#d9d9d9",
                        paddingTop: "5px",
                      }}
                    >
                      <h6>
                        <b>{getModelName(model)}</b>
                      </h6>
                      <p>
                        Supported formats:{" "}
                        {getSupportedFormats(model).map((format, index) => (
                          <>
                            <span key={index}>{format} </span>
                          </>
                        ))}
                      </p>
                    </Container>}
                    {
                      model=="deepseekr1" && <Container>
                        <i>Attachments aren't supported yet</i>
                      </Container>
                    }
                    {!is_premium && model !== "deepseekr1" && <Container> {/* Add message for non-premium */}
                        <i>File attachments require Pro or Platinum plan.</i>
                      </Container>}
                  </Tooltip>
                }
              >
                {/* Wrap Button in span to allow tooltip even when disabled */}
                <span style={{ display: 'inline-block', cursor: !is_premium ? 'not-allowed' : 'pointer' }}>
                  <Button
                    disabled={model == "deepseekr1" || !is_premium} // Disable if not premium
                    onClick={(e) => {
                      e.preventDefault();
                      if (!is_premium) {
                        premiumFeatureToast();
                        return;
                      }
                      if (uploadAttachmentRef.current) {
                        uploadAttachmentRef.current.click();
                      }
                    }}
                    className="ms-2 border-0"
                    variant="outline-light"
                    style={!is_premium ? { pointerEvents: 'none', opacity: 0.6 } : {}} // Style disabled button
                  >
                    <FontAwesomeIcon icon={faPaperclip} />
                  </Button>
                </span>
              </OverlayTrigger>
              {/* <Button className="ms-2 border-0" variant="outline-light">
                <FontAwesomeIcon icon={faMicrophone} />
              </Button> */}
              <OverlayTrigger
                placement={"top"}
                overlay={
                  <Tooltip
                    id={`tooltip-top-internet-search`} // Changed ID
                    style={{
                      borderRadius: "10px",
                    }}
                  >
                    <Container
                      style={{
                        textAlign: "left",
                        color: "#d9d9d9",
                      }}
                    >
                      {is_premium
                        ? (searchInternet ? "Using Web Search Capability" : "Enables Web Search")
                        : "Internet search requires Pro or Platinum plan."}
                    </Container>
                  </Tooltip>
                }
              >
                 {/* Wrap Button in span to allow tooltip even when disabled */}
                 <span style={{ display: 'inline-block', cursor: !is_premium ? 'not-allowed' : 'pointer' }}>
                    <Button
                      disabled={model=="deepseekr1" || !is_premium} // Disable if not premium
                      style={
                        searchInternet && is_premium // Only apply active style if premium
                          ? {
                              backgroundColor: "white",
                              color: "black",
                              opacity: "0.9",
                            }
                          : !is_premium ? { pointerEvents: 'none', opacity: 0.6 } : {} // Style disabled button
                      }
                      onClick={(e) => {
                        if (!is_premium) {
                            premiumFeatureToast();
                            return;
                        }
                        setSearchInternet(!searchInternet)
                      }}
                      className="ms-2 border-0"
                      title="Search Internet"
                      variant="outline-light"
                    >
                      <FontAwesomeIcon icon={faGlobe} />
                    </Button>
                 </span>
              </OverlayTrigger>
              <input
                type="file"
                multiple
                hidden
                ref={uploadAttachmentRef}
                onChange={handleAttachementSelect}
                disabled={!is_premium} // Disable input if not premium
              />
              {message.length === 0 && <style>{inputAnimStyles}</style>}
              <div className={`${message.length === 0? 'thinking-border': ''}`} style={{
                width: "100%"
              }}>
              <Form.Control
                as="textarea"
                rows={1}
                autoFocus={true}
                placeholder="I'm Lex, your AI companion, providing great responses with the occasional glitch."
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value);
                  // if (!ftch) getSuggestions();
                }}
                onKeyDown={handleKeyPress}
                className={`msg-inp ms-2 border-0 text-light`}
              />
              </div>
              <Button
                variant="primary"
                className="send-button ms-3 border-0"
                onClick={() => {
                  if (message.trim()) {
                    initChat();
                    setShowSuggestions(false);
                  }
                }}
                disabled={ftch}
              >
                {ftch || uploading.length > 0 ? (
                  <Spinner size="sm" />
                ) : (
                  <img src="https://www.beatai.io/favicon.png" width="20"></img>
                )}
              </Button>
            </Form.Group>
          </Form>
          <Offcanvas
            className={"text-light offcanv-hist"}
            ref={offCanvRef}
            show={show}
            as="div"
            onHide={handleClose}
          >
            <Offcanvas.Header
              closeButton
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                color: "white",
              }}
            >
              {/* History text */}
              {!searchFocused && !searchText && (
                <span
                  style={{
                    whiteSpace: "nowrap",
                    transition: "opacity 0.3s",
                    opacity: searchFocused ? 0 : 1,
                  }}
                >
                  <FontAwesomeIcon icon={faHistory} /> History
                </span>
              )}

              {/* Search Input */}
              <InputGroup
                size="sm"
                className="offcanv-hist-search"
                style={{
                  marginLeft: "auto", // Push the input to the right
                  transition: "width 0.3s",
                  padding: "9px 9px",
                  flexGrow: searchFocused || searchText ? 1 : 0,
                  width: searchFocused || searchText ? "100%" : "13rem",
                }}
              >
                <FormControl
                  type="text"
                  className="offcanv-hist-search-inp"
                  placeholder="Search"
                  value={searchText}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    e.target.value.length > 0 &&
                      searchChats(e.target.value).then((res) => {
                        setChatSearchResults(res);
                      });
                  }}
                  style={{
                    borderRadius: searchText
                      ? "0.25rem 0 0 0.25rem"
                      : "0.25rem",
                  }}
                />
                {searchText && (
                  <Button
                    variant="secondary"
                    className="offcanv-hist-search-clear"
                    onClick={handleClear}
                    style={{ borderRadius: "0.25rem" }}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>
                )}
                <Button
                  variant="primary"
                  className="offcanv-hist-search-btn"
                  style={{
                    borderRadius: searchText
                      ? "0 0.25rem 0.25rem 0"
                      : "0.25rem",
                  }}
                >
                  <FontAwesomeIcon icon={faSearch} />
                </Button>
              </InputGroup>
            </Offcanvas.Header>
            <Offcanvas.Body
              className="history-priv-social-par "
              style={{ overflowY: "auto" }}
            >
              {chatSearchResults !== null && chatSearchResults.length === 0 && (
                <p>No results found</p>
              )}
              {chatSearchResults !== null &&
                chatSearchResults.length > 0 &&
                chatSearchResults.map((ch, i) => {
                  return (
                    <>
                      <Card className="offcanv-hist-itm">
                        <Card.Body>
                          <p style={{ fontSize: "0.9em" }}>Chat: {ch.title}</p>
                          <p style={{ fontSize: "0.7em" }}>
                            <div
                              className={
                                ch.is_user_message
                                  ? "identity_user"
                                  : "identity_lex"
                              }
                            >
                              <b>
                                {ch.is_user_message ? (
                                  firstname ? (
                                    <>{firstname}:</>
                                  ) : (
                                    "User:"
                                  )
                                ) : (
                                  "Lex:"
                                )}
                              </b>
                            </div>
                            {getSearchResultMessageTxt(
                              ch.matching_message_content
                            )}
                          </p>
                        </Card.Body>
                        <Card.Footer>
                          <Row>
                            <Col sm={6} md={6} xs={6}>
                              <p style={{ fontSize: "0.7em", width: "100%" }}>
                                {new Date(ch.updated_at).toLocaleDateString()}{" "}
                                {new Date(ch.updated_at).toLocaleTimeString()}
                              </p>
                            </Col>
                            <Col sm={6} md={6} xs={6} className="d-flex">
                              <Button
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(`/chat/${ch.uuid}_${ch.id}`);
                                  setShow(false);
                                }}
                                size="sm"
                                disabled={deletingChat}
                                className="ms-auto open-chat-btn"
                              >
                                Open Chat
                              </Button>
                            </Col>
                          </Row>
                        </Card.Footer>
                      </Card>
                      <br />
                    </>
                  );
                })}
              {chatSearchResults == null &&
                chatsHistory.map((ch, i) => {
                  return (
                    <>
                      <Card className="offcanv-hist-itm">
                        <Card.Body>{ch.title}</Card.Body>
                        <Card.Footer>
                          <Row>
                            <Col sm={6} md={6} xs={6}>
                              <p style={{ fontSize: "0.7em", width: "100%" }}>
                                {new Date(ch.created_at).toLocaleDateString()}{" "}
                                {new Date(ch.created_at).toLocaleTimeString()}
                              </p>
                            </Col>
                            <Col sm={6} md={6} xs={6} className="d-flex">
                              {(chatRemConfirmID == null ||
                                chatRemConfirmID !== ch.id) && (
                                <Button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    history.push(`/chat/${ch.uuid}_${ch.id}`);
                                    setShow(false);
                                  }}
                                  size="sm"
                                  disabled={deletingChat}
                                  className="ms-auto open-chat-btn"
                                >
                                  Open
                                </Button>
                              )}
                              {(chatRemConfirmID == null ||
                                chatRemConfirmID !== ch.id) && (
                                <Button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setChatRemConfirmID(ch.id);
                                  }}
                                  size="sm"
                                  disabled={deletingChat}
                                  className="ms-auto delete-chat-btn"
                                >
                                  <FontAwesomeIcon size="xs" icon={faTrash} />{" "}
                                  Remove
                                </Button>
                              )}
                              {chatRemConfirmID !== null &&
                                ch.id == chatRemConfirmID && (
                                  <>
                                    <p
                                      className="ms-auto"
                                      style={{
                                        fontSize: "0.7em",
                                        color: "#d4d4d4",
                                        marginRight: "6px",
                                      }}
                                    >
                                      Please confirm:{" "}
                                    </p>{" "}
                                    <Button
                                      disabled={deletingChat}
                                      onClick={(e) => {
                                        setDeletingChat(true);
                                        deleteChat(ch.id)
                                          .then(() => {
                                            setDeletingChat(false);
                                            setChatRemConfirmID(null);
                                            setChatsHistory((prev) =>
                                              prev.filter((x) => x.id != ch.id)
                                            );
                                            history.push("/chat");
                                          })
                                          .catch((e) => {
                                            console.log(e);
                                            alert(
                                              "There was an issue deleting chat!"
                                            );
                                            setDeletingChat(false);
                                          });
                                      }}
                                      size="sm"
                                      className="ms-auto ms-2 delete-chat-btn"
                                    >
                                      {deletingChat ? (
                                        <Spinner size="sm" />
                                      ) : (
                                        "Delete"
                                      )}
                                    </Button>
                                    <Button
                                      disabled={deletingChat}
                                      onClick={(e) => {
                                        setChatRemConfirmID(null);
                                      }}
                                      size="sm"
                                      className="ms-auto ms-2 delete-chat-btn"
                                    >
                                      Cancel
                                    </Button>
                                  </>
                                )}
                            </Col>
                          </Row>
                        </Card.Footer>
                      </Card>
                      <br />
                    </>
                  );
                })}
              <Accordion
                onClick={() => {
                  setTimeout(() => {
                    offCanvScrollBottom();
                  }, 1000);
                }}
                alwaysOpen={false}
                className="custom-accordion"
                style={{
                  border: "none !important",
                  backgroundColor: "rgba(180, 71, 223, 0.09) !important",
                }}
              >
                <Accordion.Item
                  eventKey="0"
                  style={customAccordionStyle}
                  className="custom-accordion-item"
                  onCli
                >
                  <Accordion.Header
                    style={customHeaderStyle}
                    className="custom-accordion-header"
                  >
                    Privacy Policy and Social Media
                  </Accordion.Header>
                  <Accordion.Body
                    className="custom-accordion-body"
                    style={customAccordionStyle}
                  >
                    <Container
                      style={{
                        padding: "1px 10px",
                        color: "#d9d9d9",
                        marginTop: "5%",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="">
                        <p className="">
                          Copyright © 2024, Beatbind. <br />
                          All trademarks and copyrights belong to their
                          respective owners.
                        </p>

                        <div className="">
                          <a
                            href="https://beatbind.io/legal"
                            className="text-[#47B5F5] hover:underline"
                          >
                            Legal Information
                          </a>

                          <span className="text-white"> | </span>

                          <a
                            href="https://beatbind.io/privacy"
                            className="text-[#47B5F5] hover:underline"
                          >
                            Privacy Policy
                          </a>

                          <span className="text-white"> | </span>

                          <a
                            href="https://beatbind.io/pledge"
                            className="text-[#47B5F5] hover:underline"
                          >
                            Pledge Policy
                          </a>
                        </div>

                        <div style={{ width: "100%", textAlign: "left" }}>
                          <br />
                          <ul
                            className=""
                            style={{
                              display: "inline-block",
                              paddingLeft: "0px",
                            }}
                          >
                            <li
                              style={{
                                display: "inline-block",
                                margin: "4px 4px",
                              }}
                            >
                              <a
                                target="_blank"
                                href="https://t.me/beatbindutilitytoken"
                                className="text-white hover:text-blue-500 transition"
                              >
                                <i class="fa-brands fa-telegram"></i>
                              </a>
                            </li>
                            <li
                              target="_blank"
                              style={{
                                display: "inline-block",
                                margin: "4px 4px",
                              }}
                            >
                              <a
                                href="https://www.facebook.com/beatbind/"
                                className="text-white hover:text-blue-600 transition"
                              >
                                <i class="fa-brands fa-facebook"></i>
                              </a>
                            </li>
                            <li
                              target="_blank"
                              style={{
                                display: "inline-block",
                                margin: "4px 4px",
                              }}
                            >
                              <a
                                href="https://t.me/BeatBind_BBND"
                                className="text-white hover:text-blue-500 transition"
                              >
                                <i class="fa-brands fa-telegram"></i>
                              </a>
                            </li>
                            <li
                              target="_blank"
                              style={{
                                display: "inline-block",
                                margin: "4px 4px",
                              }}
                            >
                              <a
                                href="https://www.linkedin.com/company/beatbind"
                                className="text-white hover:text-blue-700 transition"
                              >
                                <i class="fa-brands fa-linkedin"></i>
                              </a>
                            </li>
                            <li
                              target="_blank"
                              style={{
                                display: "inline-block",
                                margin: "4px 4px",
                              }}
                            >
                              <a
                                href="https://twitter.com/beat_bind"
                                className="text-white hover:text-black transition"
                              >
                                <i class="fa-brands fa-x-twitter"></i>
                              </a>
                            </li>
                            <li
                              target="_blank"
                              style={{
                                display: "inline-block",
                                margin: "4px 4px",
                              }}
                            >
                              <a
                                href="https://www.instagram.com/beatbindgram/"
                                className="text-white hover:text-pink-500 transition"
                              >
                                <i class="fa-brands fa-instagram"></i>
                              </a>
                            </li>
                            <li
                              target="_blank"
                              style={{
                                display: "inline-block",
                                margin: "4px 4px",
                              }}
                            >
                              <a
                                href="https://medium.com/@beatbind"
                                className="text-white hover:text-green-500 transition"
                              >
                                <i class="fa-brands fa-medium"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Container>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Offcanvas.Body>
          </Offcanvas>
        </Container>
      </Container>
      <APIProvider apiKey={MAP_KEY}>
      <OffCanvNavigate
        userLocationTxt={userLocation}
        eventObject={navigatingEvent.eventObject}
        show={navigatingEvent.open}
        onHide={() =>
          setNavigatingEvent({
            open: false,
            eventObject: {},
          })
        }
      />
      </APIProvider>
      <ModelCapabilities
        current_plan={currentPlan} // Pass the current plan object
        model={model}
        setModel={setModel}
        show={showModelComparison}
        handleClose={() => {
          setShowModelComparison(false);
        }}
        handleShow={() => {
          setShowModelComparison(true);
        }}
        modelChangeToast={modelChangeToast}
      />
      <ToastContainer />
    </>
  );
}

export default Chat;
